module.exports = __webpack_public_path__ + "static/media/meal.e2257fd7.svg";